import { ChartTimeFormat, TREATMENT_UNIT_TYPE, TIME_SETTING_TYPE, ADDITIVE_UNIT_TYPE, FLUID_UNIT_TYPE, DEFAULT_DIGIT_AFTER_DECIMAL } from './../../../shared/helpers/app.constants';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { Subscription, Observable, of, forkJoin, BehaviorSubject } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';
import { NbDialogService } from '@nebular/theme';
import { TreatmentService } from '../../../shared/services/treatment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError, flatMap, finalize } from 'rxjs/operators';
import { ITimeRangeFilter } from '../../../shared/services/charts/base-chart.service';
import { findIndex, isEmpty, orderBy, isFunction, isNil } from 'lodash';
import { IChannelSettingModel } from '../../../shared/models/channel.model';
import { MultiFlowDataChartComponent } from '../../../shared/components/charts';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { UserRolesService } from '../../../shared/services/user-roles.service';
import { LoadingOverlayService } from '../../../shared/services/loading-overlay.service';
import { CustomNumberDecimal1Component } from '../../../shared/components/custom-smart-table/custom-number-decimal-1.component';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { ITreatmentComment } from '../../../shared/models';
import { IDiagnosticPoint } from '../../../shared/models/diagnostic-points.model';
import { TreatmentPlotComponent } from '../../../shared/components/treatment-plot/treatment-plot.component';
import { ITreatmentPlotDataState } from '../../../shared/models/treatment-plot.model';
import { TREATMENT_TYPE, ENUM_TREATMENT_TYPE } from '../../../shared/helpers/app.constants';
import { UnitSystemService } from '../../../shared/services/unit-system.service';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-treatment-details',
  templateUrl: './treatment-details.component.html',
  styleUrls: ['./treatment-details.component.scss']
})
export class TreatmentDetailsComponent implements OnInit, OnDestroy {
  TREATMENT_UNIT_TYPE = TREATMENT_UNIT_TYPE;
  DEFAULT_DIGIT_AFTER_DECIMAL = DEFAULT_DIGIT_AFTER_DECIMAL;

  @ViewChild(MultiFlowDataChartComponent) highChart: MultiFlowDataChartComponent;
  @ViewChild(TreatmentPlotComponent) treatmentPlot: TreatmentPlotComponent;

  subscriptions: Subscription[] = [];
  isDataFiles: boolean = false;

  // Button dropdown
  optionsOpened: boolean = false;
  exportList: string[] = ['Save PNG', 'Save JPEG', 'Print Chart'];

  isFieldEngineer: boolean = false;
  isCarboAdmin: boolean = false;
  // WellId
  wellId: number;

  isLoadingChartData: boolean = false;
  isLoadingGridData: boolean = false;
  isDisplayTooltip: boolean = true;
  isDisplayComment: boolean = true;
  listCommentsOptions: boolean = true;
  selectedCommentType: string = 'Annotation';
  TIME_SETTING_TYPE = TIME_SETTING_TYPE;
  timeFormat: ChartTimeFormat = TIME_SETTING_TYPE.OffsetTime;
  listChannels: any[] = [];
  listFracProChannels: any[] = [];

  // loading: boolean = true;
  treatmentData: boolean = false;
  notFoundData: boolean = true;

  channelMapping: any[] = [];

  // List Treatment
  listTreatment: any[] = [];
  selectedTreatment: any[] = [];
  treatmentId: number;
  indexTreatment: number = 0;
  autoScaleDefault: boolean = false;

  paramWells: any = {
    wellName: null,
    wellUid: null,
    serviceCompanyName: null,
    operatorName: null,
    treatmentId: null
  };
  paramTreatment: any;
  // Table Proppant
  tableProppantSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    rowClassFunction: (row) => {
      if (row.data.name === 'Total Proppant (lbm)') {
        return 'column-bold';
      } else {
        return 'column-normal';
      }
    },
    attr: {
      class: 'last-column-text-right',
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      no: {
        title: 'No.',
        type: 'string',
        width: '8%',
        sort: false,
      },
      name: {
        title: 'Name',
        type: 'string',
        width: '62%',
        sort: false,
      },
      strap: {
        title: 'Actual',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantity: {
        title: 'Metered',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantityFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };
  // Table Additive
  tableAdditiveSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    attr: {
      class: 'last-column-text-right',
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      no: {
        title: 'No.',
        type: 'string',
        width: '8%',
        sort: false,
      },
      name: {
        title: 'Name',
        type: 'string',
        width: '47%',
        sort: false,
      },
      kind: {
        title: 'Kind',
        type: 'string',
        width: '15%',
        sort: false,
      },
      strap: {
        title: 'Actual',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantity: {
        title: 'Metered',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantityFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };
  // Table Fluid
  tableFluidSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    rowClassFunction: (row) => {
      if (row.data.name === 'Total Fluid (bbl)') {
        return 'column-bold';
      } else {
        return 'column-normal';
      }
    },
    attr: {
      class: 'last-column-text-right',
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      no: {
        title: 'No.',
        type: 'string',
        width: '8%',
        sort: false,
      },
      name: {
        title: 'Name',
        type: 'string',
        width: '47%',
        sort: false,
      },
      kind: {
        title: 'Kind',
        type: 'string',
        width: '15%',
        sort: false,
      },
      strap: {
        title: '',
        type: 'string',
        class: 'text-right',
        width: '12%',
        sort: false,
      },
      fluidVol: {
        title: 'Volume',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      fluidVolFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };

  dataProppant: LocalDataSource = new LocalDataSource();
  dataAdditive: LocalDataSource = new LocalDataSource();
  dataFluid: LocalDataSource = new LocalDataSource();

  chartInputData: any = [];
  channelSettings: IChannelSettingModel;
  filterSettings: any = {
    type: this.timeFormat,
    startIndex: 0,
    endIndex: 0
  };
  timeRangeFilterValues: ITimeRangeFilter;

  listFlowpaths = [];
  selectedFlowpath: any[];
  listTreatmentComments: ITreatmentComment[] = [];
  originalTreatmentComments: ITreatmentComment[];
  flagKeys = ['isDisplayTooltip', 'isDisplayComment', 'timeFormat'];
  wellTimeZoneOffset: number = null;
  listDiagnosticPoints: IDiagnosticPoint[] = [];
  userCompanyId: number = null;
  isDisplayDiagnostics: boolean = false;

  wellInfo: any;
  queryParams: { wellId: number; treatmentId: number } = { wellId: null, treatmentId: null };

  selectedTreatment$: BehaviorSubject<any> = new BehaviorSubject(null);
  treatmentName$: Observable<any> = this.selectedTreatment$.asObservable().pipe(map(treatment => {
    if (treatment) {
      if (TREATMENT_TYPE[treatment.dataType] !== ENUM_TREATMENT_TYPE.Monitoring) {
        return `${TREATMENT_TYPE[treatment.dataType]} ${treatment.treatmentNumber}`;
      } else {
        return `${TREATMENT_TYPE[treatment.dataType]}`;
      }
    }
    return;
  }));
  isShowSummary$: Observable<boolean> = this.selectedTreatment$.asObservable().pipe(map(treatment => {
    if (treatment) {
      return TREATMENT_TYPE[treatment.dataType] !== ENUM_TREATMENT_TYPE.Monitoring;
    }
    return true;
  }));
  isShowTableDetail$: Observable<boolean> = this.selectedTreatment$.asObservable().pipe(map(treatment => {
    if (treatment) {
      return TREATMENT_TYPE[treatment.dataType] === ENUM_TREATMENT_TYPE.Treatment;
    }
    return true;
  }));
  isDFITMinifrac$: Observable<boolean> = this.selectedTreatment$.asObservable().pipe(map(treatment => {
    if (treatment) {
      return TREATMENT_TYPE[treatment.dataType] === ENUM_TREATMENT_TYPE.DFIT || TREATMENT_TYPE[treatment.dataType] === ENUM_TREATMENT_TYPE.Minifrac;
    }
    return false;
  }));

  treatmentData$: BehaviorSubject<any> = new BehaviorSubject(null);
  isMonitoring$: Observable<boolean> = this.treatmentData$.asObservable().pipe(map(treatment => {
    if (treatment) {
      return TREATMENT_TYPE[treatment.dataType] === ENUM_TREATMENT_TYPE.Monitoring;
    }
    return false;
  }));

  constructor(
    private dialogService: NbDialogService,
    private treatmentService: TreatmentService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private loadingOverlayService: LoadingOverlayService,
    private route: ActivatedRoute,
    private router: Router,
    private unitSystemService: UnitSystemService
  ) {
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    // set flag roles
    if (this.userRolesService.isCarboAdmin(userRole)) {
      this.isCarboAdmin = true;
    } else if (this.userRolesService.isFieldEngineer(userRole)) {
      this.isFieldEngineer = true;
    }
    // check role to show data files button
    if (this.userAuthService.isCarboUser()) {
      if (!this.userRolesService.isFieldEngineer(userRole)) {
        this.isDataFiles = true;
      }
    } else {
      if (!this.userRolesService.isFieldEngineer(userRole)) {
        this.isDataFiles = userInfo.canHaveDataFiles;
      }
    }
    if (userInfo.companyId) {
      this.userCompanyId = userInfo.companyId;
    }
  }

  ngOnInit() {
    this.selectedFlowpath = [this.listFlowpaths[0]];
    this.loadingOverlayService.show();
    const subs = this.route.params.pipe(
      map((params) => {
        const id = +params.id;
        return id;
      }),
      flatMap((id) => {
        if (typeof id === 'number' && !isNaN(id)) {
          this.wellId = id;
          return this.getListTreatment(id);
        } else {
          this.notFoundData = false;
          this.loadingOverlayService.hide();
          return of([]);
        }
      }),
      flatMap(listTreatments => {
        this.listTreatment = listTreatments;
        return this.route.queryParams.pipe(flatMap(param => {
          this.loadingOverlayService.hide();
          if (param) {
            this.paramWells.wellName = param.wellName;
            this.paramWells.wellUid = param.wellUid;
            this.paramWells.serviceCompanyName = param.serviceCompanyName;
            this.paramWells.operatorName = param.operatorName;
            this.paramWells.treatmentId = param.treatmentId * 1;
          }

          return of(this.paramWells);
        }));
      }),
      finalize(() => {
      })
    ).subscribe((params) => {
      if (!isEmpty(this.listTreatment)) {
        let curTreatment = this.listTreatment[0];
        if (this.paramWells.treatmentId) {
          const curTreatmentIndex = findIndex(this.listTreatment, { id: this.paramWells.treatmentId });
          if (curTreatmentIndex > -1) {
            // set index treatment
            this.indexTreatment = curTreatmentIndex;
            // set currently selected treatment
            curTreatment = this.listTreatment[curTreatmentIndex];
          }
        }
        this.selectedTreatment = [curTreatment];
        this.treatmentId = curTreatment.id;

        // set query params
        this.setQueryParams(this.wellId, this.treatmentId);

        this.getTreatmentDetail(this.wellId, this.treatmentId, () => {
          this.selectedTreatment$.next(curTreatment);
        });
      }
    });
    this.subscriptions.push(subs);
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  setQueryParams(wellId, treatmentId) {
    this.queryParams = {
      wellId,
      treatmentId
    };
  }

  onInitTreatmentPlot(eventData: ITreatmentPlotDataState) {
    this.isLoadingChartData = false;
    if (eventData) {
      this.wellInfo = eventData.wellInfo;
      this.listFlowpaths = eventData.listFlowpaths;
      this.chartInputData = eventData.chartInputData;
      this.channelSettings = eventData.channelSettings;
      this.filterSettings = eventData.filterSettings;
      this.timeRangeFilterValues = eventData.timeRangeFilterValues;
      this.listTreatmentComments = eventData.listTreatmentComments;
    }
  }

  onTreatmentPlotDataChange(eventData: ITreatmentPlotDataState) {
    if (eventData) {
      this.chartInputData = eventData.chartInputData;
      this.channelSettings = eventData.channelSettings;
      this.filterSettings = eventData.filterSettings;
    }
  }

  onTreatmentPlotCommentTypeChange({isDisplayComment, commentType}: {isDisplayComment: boolean, commentType: string}) {
    this.selectedCommentType = commentType;
    this.isDisplayComment = isDisplayComment;
  }

  changeWellSummary() {
    this.router.navigate(['pages/wells', this.wellId]);
  }

  navigateToDataFlies() {
    this.router.navigate(['pages/wells/dataFiles'], {
      queryParams: {
        wellId: this.wellId,
        treatmentId: this.treatmentId,
        treatmentName: this.paramTreatment.treatmentName,
        wellUid: this.paramWells.wellUid,
        serviceCompanyName: this.paramWells.serviceCompanyName,
        operatorName: this.paramWells.operatorName
      }
    });
  }

  getListTreatment(id: number): Observable<[]> {
    return this.treatmentService.getListTreatment(id)
      .pipe(map((res) => {
        // Sort treatment by treatment number
        const listTreatments = orderBy(res.result, item => item.treatmentNumber);
        return listTreatments;
      })).pipe(catchError((err) => {
        return [];
      }));
  }

  getTreatmentDetail(wellId: number, treatmentId: number, callbackFinalize?: VoidFunction) {
    this.isLoadingGridData = true;
    const loadGridData$ = this.treatmentService.getTreatmentDetail(wellId, treatmentId).pipe(
      map(res => {
        this.paramTreatment = res.result;
        this.treatmentData$.next(this.paramTreatment);
        this.originalTreatmentComments = this.paramTreatment.comments;
        let unit: string;
        // Proppant
        unit = this.getUnitConveter(TREATMENT_UNIT_TYPE.mass, 'lbm');
        this.dataProppant.load(res.result.proppant.map((item, index) => {
          if (item.name === 'Total Proppant (lbm)') {
            item.name = `Total Proppant ${unit}`;
            return {
              no: 'All', name: item.name,
              strap: this.convertUnit(TREATMENT_UNIT_TYPE.stMass, item.stMass, DEFAULT_DIGIT_AFTER_DECIMAL.stMass),
              quantity: this.convertUnit(TREATMENT_UNIT_TYPE.mass, item.mass, DEFAULT_DIGIT_AFTER_DECIMAL.mass) 
            };
          }
          return {
            no: index,
            name: (`${item.name} ${unit}`),
            strap: this.convertUnit(TREATMENT_UNIT_TYPE.stMass, item.stMass, DEFAULT_DIGIT_AFTER_DECIMAL.stMass),
            quantity: this.convertUnit(TREATMENT_UNIT_TYPE.mass, item.mass, DEFAULT_DIGIT_AFTER_DECIMAL.mass) 
          };
        }));
        // Additive
        unit = this.getUnitConveter(ADDITIVE_UNIT_TYPE.mass, 'lbm');
        const volUnit = this.getUnitConveter(ADDITIVE_UNIT_TYPE.volume, 'gal');

        this.dataAdditive.load(res.result.additive.map((item, index) => {
          let strap = this.convertUnit(ADDITIVE_UNIT_TYPE.stMass, item.stMass, DEFAULT_DIGIT_AFTER_DECIMAL.stMass);
          if (item.stVol > 0) {
            strap = this.convertUnit(ADDITIVE_UNIT_TYPE.stVol, item.stVol, DEFAULT_DIGIT_AFTER_DECIMAL.stVol);
          }
          if (item && item.mass) {
            return {
              no: (index + 1),
              name: `${item.name} ${unit}`,
              kind: item.kind,
              strap: strap,
              quantity: this.convertUnit(ADDITIVE_UNIT_TYPE.mass, item.mass, DEFAULT_DIGIT_AFTER_DECIMAL.mass)
            };
          } else {
            return {
              no: (index + 1),
              name: `${item.name} ${volUnit}`,
              kind: item.kind,
              strap: strap,
              quantity: this.convertUnit(ADDITIVE_UNIT_TYPE.volume, item.volume, DEFAULT_DIGIT_AFTER_DECIMAL.volume) 
            };
          }
        }));
        // Fluid table
        unit = this.getUnitConveter(FLUID_UNIT_TYPE.volume, 'bbl');
        this.dataFluid.load(res.result.fluid.map((item, index) => {
          if (item.name === 'Total Fluid (bbl)') {
            item.name = `Total Fluid ${unit}`;
            return {
              no: 'All',
              name: item.name,
              kind: item.kind,
              strap: '',
              fluidVol: this.convertUnit(FLUID_UNIT_TYPE.volume, item.fluidVol, DEFAULT_DIGIT_AFTER_DECIMAL.fluidVol) 
            };
          }
          return {
            no: index,
            name: `${item.name} ${unit}`,
            kind: item.kind,
            strap: '',
            fluidVol: this.convertUnit(FLUID_UNIT_TYPE.volume, item.fluidVol, DEFAULT_DIGIT_AFTER_DECIMAL.fluidVol) 
          };
        }));
        this.notFoundData = true;
        this.isLoadingGridData = false;
        return res;
      }));

    // load grid data then load chart data and comments
    forkJoin(loadGridData$)
      .pipe(finalize(() => {
        this.isLoadingGridData = false;
        this.loadingOverlayService.hide();
        if (isFunction(callbackFinalize)) {
          callbackFinalize();
        }
      }))
      .subscribe();
  }

  selectTreatment(e: any) {
    if (this.treatmentId !== e.id) {
      const index = findIndex(this.listTreatment, { id: e.id });
      if (index > -1) {
        this.treatmentId = e.id;
        this.indexTreatment = index;
        // set query params
        this.setQueryParams(this.wellId, this.treatmentId);
        // load treatment
        this.navigateToTreatment(this.wellId, this.treatmentId);
      }
    }
  }

  private changeTreatmentByIndex = (index) => {
    const curTreatment = this.listTreatment[index];
    if (curTreatment && curTreatment.id) {
      this.treatmentId = curTreatment.id;
      this.indexTreatment = index;
      // set query params
      this.setQueryParams(this.wellId, this.treatmentId);
      // load treatment
      this.navigateToTreatment(this.wellId, this.treatmentId);
    }
  }

  buttonFirstTreatment() {
    if (this.indexTreatment > 0) this.changeTreatmentByIndex(0);
  }

  buttonPrevTreatment() {
    this.changeTreatmentByIndex(this.indexTreatment - 1);
  }

  buttonNextTreatment() {
    this.changeTreatmentByIndex(this.indexTreatment + 1);
  }

  buttonLastTreatment() {
    if (this.listTreatment && this.indexTreatment < this.listTreatment.length - 1) this.changeTreatmentByIndex(this.listTreatment.length - 1);
  }

  onSelectFlowpath(data) {
    if (data) this.treatmentPlot.selectFlowpathHandler(data);
  }

  navigateRenameChannel() {
    this.router.navigate(['pages/renameChannel'], {
      queryParams: { wellId: this.wellId, treatmentId: this.treatmentId }
    });
  }

  private navigateToTreatment(wellId: number, treatmentId: number): void {
    this.paramWells.treatmentId = treatmentId;
    this.router.navigate(['pages/wells/treatmentDetails', wellId], { queryParams: this.paramWells })
      .then(res => {
        if (res) {
          this.treatmentPlot.reloadDataByTreatment(treatmentId);
        }
      });
  }

  onDeleteConfirm(item?: any): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${item.treatmentName}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
          data: item,
        }
      }
    }).onClose.subscribe(res => {
      if (res.confirm) {
        this.deleteTreatment();
      }
    });
  }

  onDefaultDiagnosticPointChange() {
    // update treatent dependent values
    this.getTreatmentDetail(this.wellId, this.treatmentId);
  }

  deleteTreatment() {
    this.loadingOverlayService.show();
    this.subscriptions.push(
      this.treatmentService.deleteTreatment(this.wellId, this.treatmentId).subscribe(
        (res) => {
          this.changeWellSummary();
        }, (error) => {
          this.loadingOverlayService.hide();
        }
      )
    );
  }

  formatJobTimeComment(jobtime) {
    if (this.filterSettings.type === TIME_SETTING_TYPE.OffsetTime) {
      return (jobtime / 60).toFixed(1) + ' min';
    } else {
      const baseTime = Math.floor(this.timeRangeFilterValues.timestamp.start / 1000) || 0; // sec
      return (baseTime + jobtime) * 1000; // millisecond
    }
  }

  getUnitConveter(measureType: string, curUnit: string): string {
    if (isNil(measureType) || !measureType.length) return curUnit ? `(${curUnit})` : '';
    else {
      const unit = this.unitSystemService.getUnit(measureType, undefined, curUnit);
      return unit ? `(${unit})` : '';
    }
  }

  convertUnit(measureType: string, value, decimal?: number): number | string {
    return this.unitSystemService.getValueConvert(measureType, value, decimal);
  }

}
